import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, FormControl, Grid } from '@mui/material';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsColors, WsIconMoreVer, WsTypoVariants, WsTypography } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context/WorkspaceContext/WorkspaceContext';
import { clientsAmplitudeEvents } from '../../../features/clientDetails/helper/clientDetailsHelper';
import { StyledMenuBox } from '../../../features/clientListingPage/components/ClientList';
import { ClientAction, useClientAuthz } from '../../../hooks/useClientAuthz';
import PopoverOnClick from '../../clientListingPage/components/PopoverOnClick';

interface IHeaderProps {
  title: string;
  options: string[];
  onSelect: (value: string) => void;
  isClient?: boolean;
  showBorder?: boolean;
  onCreateClient?: () => void;
}

const CommonHeader = ({
  title,
  options,
  onSelect,
  isClient,
  onCreateClient,
  showBorder,
}: IHeaderProps) => {
  const currentUser = useWorkspaceContext();
  const navigate = useNavigate();
  const titleElRef = useRef<HTMLElement | null>(null);
  const isAuthorizedAddClient = useClientAuthz(ClientAction.ADD_CLIENT_DETAILS);

  const handleAddClient = () => {
    clientsAmplitudeEvents('client_add', 'Client Creation', currentUser);
    onCreateClient?.();
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs="auto">
        <FormControl>
          <PopoverOnClick
            element={
              <Box
                ref={titleElRef}
                display="flex"
                alignItems="center"
                sx={{
                  border: showBorder ? `1px solid ${WsColors.ToolbarColor}` : 'none',
                  borderRadius: showBorder ? 2 : 0,
                  height: 35,
                  width: 110,
                }}
              >
                <WsTypography variant={WsTypoVariants.TITLE} cursor="pointer">
                  {title}
                </WsTypography>
                <KeyboardArrowDownIcon />
              </Box>
            }
          >
            {options.map((option) => (
              <Grid p={1} key={option}>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  cursor="pointer"
                  onClick={() => {
                    onSelect(option.toLowerCase().replace(' ', '_'));
                    titleElRef.current?.click();
                  }}
                >
                  {option}
                </WsTypography>
              </Grid>
            ))}
          </PopoverOnClick>
        </FormControl>
      </Grid>

      {isClient && (currentUser.owns || isAuthorizedAddClient) && (
        <Grid item xs="auto" container spacing={1}>
          <Grid item>
            <WsButton
              fullWidth
              onClick={handleAddClient}
              variant="contained"
              size="medium"
              startIcon={<AddOutlinedIcon />}
            >
              Add Client
            </WsButton>
          </Grid>
          <Grid item>
            <StyledMenuBox>
              <PopoverOnClick element={<WsIconMoreVer />}>
                <Box p={1}>
                  <WsTypography
                    cursor="pointer"
                    variant={WsTypoVariants.SUB_TITLE}
                    onClick={() => navigate('/clients/import-excel')}
                  >
                    Import Clients
                  </WsTypography>
                </Box>
              </PopoverOnClick>
            </StyledMenuBox>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default CommonHeader;
